import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import LicenseAddOnUpsertDialog from "@/v2-backoffice-client/license/addOns/catalog/LicenseAddOnUpsertDialog"

export type LicenseAddOnCreateButtonProps = ButtonProps

// The page header's New Add-on action (same placement contract as the
// customers page's Create customer), shown while the Add-ons tab is active.
// Same dialog as the row menu's edit, without an add-on.
function LicenseAddOnCreateButton(props: LicenseAddOnCreateButtonProps) {
  const { onClick, ...buttonProps } = props
  const [isCreateOpen, setIsCreateOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        data-feature-code="UI_BackofficeAddOn_Toolbar_New"
        onClick={(e) => {
          setIsCreateOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        New Add-on
      </Button>

      <LicenseAddOnUpsertDialog
        open={isCreateOpen}
        onOpenChange={setIsCreateOpen}
      />
    </>
  )
}

export default LicenseAddOnCreateButton
